import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';

import '../../../../node_modules/slick-carousel/slick/slick.css';
import '../../../../node_modules/slick-carousel/slick/slick-theme.css';

import Carousel from '../../Carousel/Carousel';

import Service from './ReputationCarouselService';
import { MaxResolutions } from '../../../Shared/Helpers/Screen';

class Review extends React.Component {
    render() {
        let review = this.props.review;


        return <div className="review-item">

            <img src={review.icon} className="review-icon" alt="icon" />

            <section className="text">
                {review.text}
            </section>

            <section className="review-info">
                {review.rating > 0 && <Rating rating={review.rating} />}

                <div className="reviewer-name">
                    {review.reviewerName}
                </div>

                <div className="car-info">
                    {review.carDescription}
                </div>

                {review.date && <div className="review-date">
                    {moment(review.date).format('MMMM, YYYY')}
                </div>
                }

                <div className="source">
                    {review.source.name}
                </div>
            </section>
        </div>
    }
}

export default class ReputationCarousel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            reviews: []
        };
    }

    componentDidMount() {
        Service.getReviews().then((data) => {
            this.setState({
                reviews: data
            });
        });
    }

    render() {
        let reviews = this.state.reviews.map((review, index) => {
            return (<div key={index}>
                <Review review={review} />
            </div>);
        });

        return (<Carousel columnsAmount={this.props.columnsAmount}>
            {reviews}
        </Carousel>);
    }
}

ReputationCarousel.propTypes = {
    columnsAmount: PropTypes.number.isRequired
};

let Rating = ({ rating }) => {
    let ratingItems = [];

    for (let i = 0; i < 5; i++) {
        let itemImage = i < rating ? "/images/components/reviews/star-filled.svg" : "/images/components/reviews/star-empty.svg";

        let ratingItem = (
            <li className="rating-item" key={i}>
                <img src={itemImage} alt="Alternate Text" />
            </li>);
        ratingItems.push(ratingItem);
    }

    return (
        <ul className="rating">
            {ratingItems}
        </ul>
    );
};


let DOMcontainers = [...document.getElementsByClassName('js-reput-component')];

DOMcontainers.forEach((container) => {
    let columnsAmount = +container.dataset.columnsAmount;

    ReactDOM.render(<ReputationCarousel columnsAmount={columnsAmount} />,
        container);
});


// WEBPACK FOOTER //
// ./Src/Components/Reputation/ReputationCarousel/ReputationCarousel.jsx